import angular from 'angular';

const glideCarousel = angular.module('glideCarousel', []);

export default glideCarousel;
